import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Input, Button, Form, Space, Select, Row, Col, message } from 'antd'
import { useForm } from "antd/lib/form/Form"
import { MinusCircleOutlined } from '@ant-design/icons'
import { axiosHandleEvent, baseAxiosNoInfo } from "../../tool/axios"
import { SelectGoodsByType } from "../../component/common/Selects"
import _ from 'lodash'

const { Option } = Select

export default function () {

    const { id }: { id: string | undefined } = useParams()
    const [spuID, setSpuID] = useState<any>()

    const [form] = useForm()

    type specsOption = {
        "id": string,
        "sku_name": string
    }

    type standard = {
        id?: string,
        sku_id: string,
        inventory_num: number,
        sale_price: number
    }

    type editStandardsParams = {
        id?: string | undefined,
        sku_id: string,
        inventory_num: number,
        sale_price: number
    }

    interface StandardsDetailProp {
        spuID?: any,
        value?: editStandardsParams[]
        onChange?: (e: editStandardsParams[]) => void
    }

    useEffect(() => {
        if (id) {
            baseAxiosNoInfo('/mall_center/put_on_off/detail', { params: { put_on_id: id } }).then((res: any) => {
                if (res) {
                    let data: any = {}

                    for (let attr in res) {
                        if (attr !== 'goods_type_id' && attr !== 'goods_spu_id') {
                            if (attr !== 'goods_sku_id') {
                                data[attr] = res[attr]

                            } else {
                                data.sku_id = res[attr]
                            }
                        }
                    }

                    form.setFieldsValue({
                        ids: {
                            goodsID: res.goods_spu_id,
                            typeID: res.goods_type_id
                        },

                        goods_put_on_arr: [data]
                    })

                    setSpuID({ goodsID: res.goods_spu_id, typeID: res.goods_type_id })
                }
            })
        }
    }, [])

    const StandardsSelect: React.FC<StandardsDetailProp> = ({ value = [], onChange, spuID = '' }) => {

        let standardRow = {
            id: undefined,
            sku_id: '',
            inventory_num: 0,
            sale_price: 0
        }

        const [fetched, setFetched] = useState<boolean>(false)
        const [standardsOption, setStandardsOption] = useState<specsOption[]>([])
        const [standars, setStandars] = useState<standard[]>([standardRow])

        useEffect(() => {
            if (spuID) {
                baseAxiosNoInfo('/global/sku_list_by_spu_id', {
                    params: {
                        spu_id: spuID.goodsID
                    }

                }).then((res: any) => {
                    res && setStandardsOption(res)
                })
            }
        }, [spuID])

        useEffect(() => {
            if (!fetched) {
                if (value.length) {
                    let s = _.cloneDeep(standars)

                    s[0].id = id
                    s[0].sku_id = value[0].sku_id
                    s[0].inventory_num = value[0].inventory_num
                    s[0].sale_price = value[0].sale_price

                    setStandars(s)
                    setFetched(true)
                }
            }
        }, [value.length])

        const triggerChange = (standars: standard[]) => {
            let postData = standars?.map((el: standard) => {
                return {
                    id: el.id,
                    sku_id: el.sku_id,
                    inventory_num: el.inventory_num,
                    sale_price: el.sale_price
                }
            })

            onChange?.(postData)
        }

        const handleInputChange = (e: any, index: number, attr: string) => {
            let s: any = _.cloneDeep(standars)
            s[index][attr] = e.target.value

            setStandars(s)
            triggerChange(s)
        }

        const handleAdd = () => {
            let s: any = _.cloneDeep(standars)
            s.push(standardRow)

            setStandars(s)
        }

        const handleSelectChange = (v: string, rowIndex: number) => {
            let s: any = _.cloneDeep(standars)
            s[rowIndex].sku_id = v

            setStandars(s)
            triggerChange(s)
        }

        const handleDeleteRow = (rowIndex: number) => {
            if (standars.length === 1) {
                message.error('最少选择一个规格')
                return
            }

            let s: any = _.cloneDeep(standars)
            s.splice(rowIndex, 1)

            setStandars(s)
        }

        return <div className="clear standards-detail">
            <Row gutter={18}>
                <Col>上架规格</Col>
                <Col>上架库存</Col>
                <Col>上架售价（幸孕鹅）</Col>
            </Row>

            {standars.map((el: standard, rowIndex: number) => <Row gutter={16} style={{ marginTop: 10 }}>
                <Col>
                    <Select value={standars[rowIndex].sku_id} onChange={(v: string) => { handleSelectChange(v, rowIndex) }}>
                        {standardsOption.map((el: specsOption) => <Option value={el.id} key={el.id}>{el.sku_name}</Option>)}
                    </Select>
                </Col>

                <Col><Input size="small" style={{ maxWidth: 130 }} value={standars[rowIndex].inventory_num} onChange={(e) => { handleInputChange(e, rowIndex, 'inventory_num') }} /></Col>
                <Col><Input size="small" style={{ maxWidth: 130 }} value={standars[rowIndex].sale_price} onChange={(e) => { handleInputChange(e, rowIndex, 'sale_price') }} /></Col>

                <Col><MinusCircleOutlined style={{ cursor: 'pointer', marginTop: 4 }} onClick={() => { handleDeleteRow(rowIndex) }} /></Col>
            </Row>)}

            <div className="standards-line"></div>

            <Button style={{ marginTop: 16 }} size="small" onClick={handleAdd}>添加上架规格</Button>
        </div>
    }

    const checkGoodsArr = (_: any, value: any) => {
        if (!value) {
            return Promise.reject('上架规格、上架库存、上架售价不能为空')
        }

        const check = () => {
            return value.every((el: any) => {
                return el.inventory_num > 0 && !(el.inventory_num).toString().includes('.') && el.sale_price > 0 && el.sku_id
            })
        }

        const checkRepeat = () => {
            let ids: string[] = []
            value.forEach((el: any) => ids.push(el.sku_id))

            return ids.length === new Set([...ids]).size
        }

        let result: boolean = check()
        let resultRepeat: boolean = checkRepeat()

        if (result && resultRepeat) {
            return Promise.resolve()
        }

        return Promise.reject('规格必选并且不能重复，上架售价和上架库存（正整数）不能小于0')
    }

    const onFinish = (values: any) => {

        let url = id ? '/mall_center/put_on_off/update' : '/mall_center/put_on_off/add'
        let postData = _.cloneDeep(values)

        delete postData.ids

        if (id) {
            postData.goods_sku_arr = postData.goods_put_on_arr
            delete postData.goods_put_on_arr
        }

        axiosHandleEvent.post(url, {
            ...postData
        })
    }

    return (<div className="common-level2-edit">
        {/* 商城中心 -> 商品管理 -> 商品上架管理 -> 新增或编辑 */}
        <h2>{(id ? '编辑' : '新增') + '商品上架'}</h2>

        <div className="common-main">
            <Form form={form} name="basic" onFinish={onFinish}>

                <Form.Item
                    label="商品"
                    name="ids"
                    rules={[{ required: true, message: '选择商品' }]}
                >
                    <SelectGoodsByType showSearch sceneType={2} disabled={id ? true : false} onChange={(v: any) => { setSpuID(v) }} />
                </Form.Item>

                <Form.Item
                    required
                    label="商品规格"
                    name="goods_put_on_arr"
                    rules={[{ validator: checkGoodsArr }]}
                >
                    <StandardsSelect spuID={spuID} />
                </Form.Item>

                <Form.Item>
                    <Space>
                        <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" htmlType="submit">提交</Button>
                        <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>
    </div>)
}